import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { productImport, productImportType } from '../../types/slices/productImportType'

const initialState: productImportType =
{
    status: ApiStatus.FETCHED,
    products: [],
    productSelected: {} as productImport,
    errorMessage: undefined,
    action: ''
}

const ProductImportSlice = createSlice({
    name: 'ProductImportSlice',
    initialState,
    reducers: {
        onFetchProductsImport (state, { payload }: { payload: productImport[]}) {
            state.status = ApiStatus.FETCHED
            state.products = payload
            state.errorMessage = undefined
        },
        onSetSelectedProductImport (state, { payload }: { payload: productImport }) {
            state.productSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectProductImportState = (state: RootState) => state.ProductImportSlice
export default ProductImportSlice.reducer
export const {
    onFetchProductsImport,
    onSetSelectedProductImport,
    changeStatus,
    setAction,
} = ProductImportSlice.actions
